
<div class="newsCard"   (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
  <app-background-local #background ></app-background-local>
  <div class="global" >
    @if(currentNews && !currentNews.video){
      @if(! safetyIconUrl){
      <div class="global image-container" [@imageContainerSlide]="{ value: imageContainerState, params: imageContainerAnimationParams }" >
        <div   [class.translateImg]="moveToTheLeft && currentNews.withAnimation" 
            [class.translateImgForSecondImage]="moveToTheLeft && hasSecondImage()"
            [@fadeInZoomSlowBig]="zoomIn ? 'in':'out'"  class="newsCardImage" [class.ratio-container]="isFirstImagePortrait"
            [style.background-image]="isFirstImagePortrait ? 'url(' + staticFirstImageUrl + ')' : ''"
            >
            @if(isFirstImagePortrait){
            <div class="blurry">
            </div>
            }
            <img [src]="getFirstImage(currentNews)" alt="" [class.keep-ratio]="isFirstImagePortrait" fallback="../assets/logo/defaultThumbnail.png" />
        </div>
        @if(currentNews.withAnimation){
          <div id="animation" [class.translateAnimation]="moveToTheLeft">
            <img 
              [src]="animationUrl" 
              alt="" 
              class="animationImage"  />
          </div>
        }
        @else if(currentNews && currentNews.images && currentNews.images.length > 1){
          <div id="secondImage" [class.translateAnimation]="moveToTheLeft"
            [style.background-image]="isSecondImagePortrait ? 'url(' + currentNews.images[1] + ')' : ''"
            [class.ratio-container]="isSecondImagePortrait"
          >
            @if(isSecondImagePortrait){
            <div class="blurry">
            </div>
            }
            <img 
              [src]="currentNews.images[1]" 
              alt="" 
              class="secondImage" [class.keep-ratio]="isSecondImagePortrait" fallback="../assets/logo/defaultThumbnail.png"/>
          </div>
        }
        
      </div>
      }
      @if( currentNews.subType && safetyIconUrl){
        <div class="safety-animation-container">
          <div class="title-section">
            <img [style.opacity]="safetyIconUrl ? '1' : '0'" [@fadeZoom]="animOut ? 'out':'in'" [src]="safetyIconUrl" alt=""/>
            <h2 [@fadeZoom]="animOut ? 'out':'in'">{{ 'LOCAL.SUBTYPE.' + currentNews.subType | uppercase | translate }}</h2>
          </div>

          <div [@fadeZoom]="animOut ? 'out':'in'" class="carousel-section" >
            <pre class="info"  [@leaveDownSlow]="animOut" [@fadeInSlow]="animOut">{{currentNews.text}}</pre>
          </div>
        </div>
      }
    }
    @if(currentNews && currentNews.video){
        <div class="video-container"  [@fadeInZoomSlowBig]="zoomIn ? 'in':'out'">
            <video
              #videoLocal
              id="videoLocal"
              [src]="currentNews.video"
              class="video"
              preload="metadata"
              muted="true"
              (loadedmetadata)="onVideoMetadataLoaded()"
            ></video>
            <div *ngIf="!videoIsPlaying" class="playpause"></div>
        </div>
      }

  <div class="newsCardText" 
       *ngIf="currentNews" 
       [@newsCardAnimation]="showNewsCardText ? 'up' : 'down'"
     >
  <!-- Informations de publication (Auteur et Date) -->
  <div class="bandeau-haut">
    <div class="tag-container" [style.background-color]="currentNews.background.image" >
      <div class="tag" >
            <p>{{'LOCAL.TITLE' | translate}}</p>
            <div class="tag-in" [style.background-color]="currentNews.tagColor" >
              <p>{{('LOCAL.TAG.' + currentNews.tag) | uppercase | translate | uppercase}}</p>
            </div>
      </div>
    </div>
    <div class="tabs">    
      <svg *ngFor="let tab of [1,2,3,4,5]; let i = index" [class]="tab === 1 ? 'tab__1' : 'tab__2'" [class.translateTab]="animTabs" [style.zIndex]="900 - (i * 100)" width="169" height="63.16" viewBox="0 0 169 63.16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g [attr.filter]="'url(#filter0_d_tab' + (i + 2) + ')'">
          <path d="M158.333 51.335C142.835 51.335 136.323 38.785 132 28.5007L128.938 21.5014C126.938 17.5025 117.5 0.000564635 92 0H0V61.5H158.333V51.335Z" [attr.fill]="currentNews.background.image"/>
          @if(tab > 1){
            <path d="M158.333 51.335C142.835 51.335 136.323 38.785 132 28.5007L128.938 21.5014C126.938 17.5025 117.5 0.000564635 92 0H0V61.5H158.333V51.335Z" fill="black" fill-opacity="0.1"/>
          }
        </g>
        <defs>
          <filter [attr.id]="'filter0_d_tab' + (i + 2)" x="0" y="0" width="168.334" height="68.16" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="6.67" dy="3.33"/>
            <feGaussianBlur stdDeviation="1.665"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" [attr.result]="'effect1_dropShadow_tab' + (i + 2)"/>
            <feBlend mode="normal" in="SourceGraphic" [attr.in2]="'effect1_dropShadow_tab' + (i + 2)" result="shape"/>
          </filter>
        </defs>
      </svg>
    </div>
  </div>
  <!-- Contenu de la carte -->
  <div class="newsCardContent" [style.background-color]="currentNews.background.image">
    <!-- Titre -->
    <div class="newsCardTitle">
      <h1 [innerHTML]="currentNews.title"></h1>
    </div>
  </div>
  </div>
</div>

